import React from "react";
import ReactMarkdown from "react-markdown";

import { Button } from "@vwfs-bronson/bronson-react";

const BRAND = process.env.REACT_APP_BRAND || "vwn";
const Text = require(`./${BRAND}/translations.json`);
class Output {
  static resolve(key, defaultValue) {
    try {
      return key
        .split(/[.[]/)
        .map((k) => k.replace(/]/, ""))
        .reduce((p, c) => p[c], Text);
    } catch (err) {
      console.error(`There is no resource with key ${key}`);
      return defaultValue;
    }
  }

  static markdown(v) {
    return (
      <ReactMarkdown
        source={v}
        renderers={{
          link: ({ href, children }) => (
            <Button element="a" link href={href} target="_blank">
              {children}
            </Button>
          ),
        }}
        unwrapDisallowed
      />
    );
  }

  static resolveAsMarkdown(key) {
    return Output.markdown(Output.resolve(key));
  }

  static template(text, values) {
    return text.replace(/\${([^}]*)}/, (match, p1) => values[p1]);
  }

  static templateWithValues(text, values) {
    let result = text;
    const regex = /\${([^}]*)}/g;
    const matchAll = text.matchAll(regex)
    for (const m of matchAll) {
      result = result.replace(m[0], values[m[1]]);
    }
      return result;
  }
}

const link = Output.markdown;
const resolve = Output.resolve;
const generic = Output.markdown;
const template = Output.template;
const templateWithValues = Output.templateWithValues

export { Text as Values, link, resolve, generic, template, templateWithValues, Output };
